'use strict';

var helper = require('../helper');

/**
 * Adds reg_flow_position (NEW REG FLOW - unified registration) to the push object.
 * Value is either "landing_page" (standalone newLogin.isml page) or "modal" (layerLogin.isml modal).
 * The property is omitted entirely for legacy flows where it isn't tracked.
 * @param {Object} pushObject - dataLayer object being constructed
 * @param {string} [regFlowPosition] - "landing_page" | "modal"
 * @returns {Object} the modified pushObject
 */
function addRegFlowPosition (pushObject, regFlowPosition) {
    if (regFlowPosition) {
        pushObject.reg_flow_position = regFlowPosition;
    }
    return pushObject;
}

var SOCIAL_NAME_MAP = {
    'googleplus': 'google'
};

function normalizeSocialName (socialName) {
    if (!socialName) {
        return socialName;
    }
    var name = String(socialName).toLowerCase();
    return SOCIAL_NAME_MAP[name] || name;
}

module.exports = {
    // 7.8 LOGIN NEW REG FLOW
    pushLoginInteraction (type, socialName, rememberMe, sessionExpired, location, error, regFlowPosition) {
        let isSocial = type === 'social_login' || !!socialName;
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '8',
            'eventname': 'user',
            'type': type || (isSocial ? 'social_login' : 'login'),
            'step': error ? 'step1_error' : 'step1_success',
            'method': normalizeSocialName(socialName) || '',
            'position': location,
            'category': isSocial ? '' : (rememberMe ? 'yes' : 'no'),
            'area': sessionExpired ? 'yes' : 'no'
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing login interaction:', true);
        helper.push(pushObject);
    },

    // 7.9 PERSONAL AREA PROFILE REGISTRATION: REQUEST - STEP1 NEW REG FLOW
    pushRegisterInteraction (type, location, error, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '9',
            'eventname': 'sign_up_start',
            'step': error ? 'step1_error' : 'step1_success',
            'type': type || 'site',
            'position': location || 'subscription_form'
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing register interaction - step 1:', true);
        helper.push(pushObject);
    },

    // 7.10 PERSONAL AREA PROFILE REGISTRATION: TELEPHONE NUMBER - STEP 2 NEW REG FLOW
    pushRegisterInteractionTelephone (error, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '69',
            'eventname': 'sign_up_step',
            'step': error ? 'step2_phone_error' : 'step2_phone_success'
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing register interaction - step 2:', true);
        helper.push(pushObject);
    },

    // 7.11 PERSONAL AREA PROFILE REGISTRATION: PERSONAL DATA - STEP 3 NEW REG FLOW
    pushRegisterInteractionPersonalData (typeReg, error, location, rememberMe, regFlowPosition, privacyNews, privacyCustomNews) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '70',
            'eventname': 'sign_up_step',
            'step': error ? 'step3_personal_data_error' : 'step3_personal_data_success',
            'type': (error && !regFlowPosition) ? '' : typeReg,
            'category': rememberMe ? 'yes' : 'no',
            'position': location || 'subscription_form',
            'privacy_news': privacyNews ? 'on-news_and_promotions' : 'off-news_and_promotions',
            'privacy_custom_news': privacyCustomNews ? 'on-custom_news_and_promotions' : 'off-custom_news_and_promotions'
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing register interaction - step 3:', true);
        helper.push(pushObject);
    },

    // 7.12 PERSONAL AREA PROFILE REGISTRATION: THANK YOU PAGE NEW REG FLOW
    pushRegisterConfirmInteraction (location, result, typeOfAccount, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '71',
            'eventname': 'sign_up_step',
            'step': 'step4_thankyou_page',
            'position': location || 'subscription_form',
            'type': typeOfAccount
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing register interaction - step 4:', true);
        helper.push(pushObject);
    },

    // 7.13 PERSONAL AREA PROFILE REGISTRATION: CONFIRMATION - DOUBLE OPTIN NEW REG FLOW
    pushRegisterConfirmInteractionDoubleOptin (result, typeOfAccount, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '10',
            'eventname': 'sign_up',
            'step': 'confirmation_' + (result || 'success')
        };
        if (typeOfAccount) {
            pushObject.type = typeOfAccount;
        }
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing register interaction - double optin:', true);
        helper.push(pushObject);
    },

    // 7.62 FRONT-END ERROR
    pushLoginOrRegistrationError (type, step, errorMsg) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '62',
            'eventname': 'frontend_error',
            'type': type,
            'step': step,
            'text': errorMsg
        };
        helper.log('Pushing front-end error interaction', true);
        helper.push(pushObject);
    },

    // 7.68 LOYALTY CARD SUBSCRIPTION NEW REG FLOW
    pushRegisterInteractionLoyaltyRegistration (analyticsMode) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '73',
            'eventname': 'loyalty_card_create',
            'type': analyticsMode
        };

        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    pushRegisterInteractionLoyalty (mode) {
        this.pushRegisterInteractionLoyaltyRegistration(mode);
    },

    pushUpdateAddress (eventAction) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '60',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step_1',
            'position': 'my_account'
        };
        helper.push(pushObject);
    },

    pushSaveUpdateAddress (eventAction) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '61',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step2'
        };
        helper.push(pushObject);
    },

    pushAddCreditCard (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '58',
            'eventname': 'credit_card',
            'action': 'add_credit_cart',
            'step': 'step1',
            'position': location
        };
        helper.log('Pushing adding credit card', true);
        helper.push(pushObject);
    },

    pushSaveCreditCard (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '59',
            'eventname': 'credit_card',
            'action': 'add_credit_card',
            'step': 'step2_save',
            'position': location
        };
        helper.log('Pushing saving credit card', true);
        helper.push(pushObject);
    },

    pushUpdateCreditCard (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '64',
            'eventname': 'credit_card',
            'action': action,
            'position': 'my_account'
        };
        helper.log('Pushing update credit card', true);
        helper.push(pushObject);
    },

    pushThankyouRegisterLoyalty (userID) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '104',
            'eventname': 'sign_up_for_the_loyalty_program'
        };

        helper.log('Pushing register loyalty from thank you: ', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationInteraction (socialName, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '85',
            'eventname': 'social_sign_up_start',
            'step': 'click_button',
            'method': normalizeSocialName(socialName)
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social registration for ' + socialName + ':', true);
        helper.push(pushObject);
    },

    pushNewsletterPreferenceSave (direktMarketingAgreement, profilingAgreement, brandCodes) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '150',
            'eventname': 'privacy_consent',
            'action': 'change_preferences',
            'position': 'account',
            'label': brandCodes,
            'privacy_news': direktMarketingAgreement ? 'on-news_and_promotions' : 'off-news_and_promotions',
            'privacy_custom_news': profilingAgreement ? 'on-custom_news_and_promotions' : 'off-custom_news_and_promotion'
        };

        helper.log('Pushing newsletter preference info: ', true);
        helper.push(pushObject);
    },

    // 7.81 SOCIAL REGISTRATION - STEP 1 NEW REG FLOW
    pushSocialRegistrationStep1Interaction (type, socialName, error, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '86',
            'eventname': 'social_sign_up_step',
            'step': error ? 'registration_step1_error' : 'registration_step1_success',
            'label': type,
            'method': normalizeSocialName(socialName)
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social register interaction - step 1:', true);
        helper.push(pushObject);
    },

    // 7.82 SOCIAL REGISTRATION - STEP 2 NEW REG FLOW
    pushSocialRegistrationStep2Interaction (type, socialName, error, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '87',
            'eventname': 'social_sign_up_step',
            'step': error ? 'registration_step2_error' : 'registration_step2_success',
            'label': type,
            'method': normalizeSocialName(socialName)
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social register interaction - step 2:', true);
        helper.push(pushObject);
    },

    // 7.83 SOCIAL REGISTRATION - STEP 3 NEW REG FLOW
    pushSocialRegistrationStep3Interaction (type, socialName, error, rememberMe, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '88',
            'eventname': 'social_sign_up_step',
            'step': error ? 'registration_step3_personal_data_error' : 'registration_step3_personal_data_success',
            'text': type,
            'method': normalizeSocialName(socialName),
            'category': rememberMe ? 'yes' : 'no'
        };
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social register interaction - step 3:', true);
        helper.push(pushObject);
    },

    // 7.84 SOCIAL REGISTRATION - THANK YOU PAGE NEW REG FLOW
    pushSocialRegistrationThankYouInteraction (socialName, result, typeOfAccount, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '89',
            'eventname': 'social_sign_up_thankyou',
            'step': 'registration_thankyou_page_' + (result || 'success'),
            'method': normalizeSocialName(socialName)
        };
        if (typeOfAccount) {
            pushObject.text = typeOfAccount;
        }
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social register interaction - thank you page:', true);
        helper.push(pushObject);
    },

    // 7.85 SOCIAL REGISTRATION - CONFIRMATION NEW REG FLOW
    pushSocialRegistrationConfirmInteraction (socialName, result, typeOfAccount, regFlowPosition) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '90',
            'eventname': 'social_sign_up',
            'step': 'registration_confirmation_' + (result || 'success'),
            'method': normalizeSocialName(socialName)
        };
        if (typeOfAccount) {
            pushObject.text = typeOfAccount;
        }
        addRegFlowPosition(pushObject, regFlowPosition);
        helper.log('Pushing social register interaction - confirmation:', true);
        helper.push(pushObject);
    },

    pushDeleteAccount () {
        helper.log('Pushing delete account interaction!', true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '208',
            'eventname': 'delete_account'
        });
    },

    pushDeleteAccountSuccess () {
        helper.log('Pushing delete account success interaction!', true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '209',
            'eventname': 'delete_account_success'
        });
    },

    pushPersistentLoginTooltipInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '97',
            'eventname': 'persistent_login_more_info'
        };

        helper.log('Pushing persistent login tooltip interaction', true);
        helper.push(pushObject);
    },

    // 7.98 ACTIONS ON THE BUTTONS (GENERAL_CTA) NEW REG FLOW, LOYALTY
    pushActionsOnTheBottomsInteraction (action, location, regFlowPosition) {
        if (!action || !location) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '105',
            'eventname': 'general_cta',
            'action': action,
            'label': location
        };
        addRegFlowPosition(pushObject, regFlowPosition);

        helper.log('Pushing actions on the bottoms interaction', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsTabsInteraction (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '109',
            'eventname': 'my_reviews',
            'area': topic
        };

        helper.log('Pushing rating and reviews interaction - account page - tabs', true);
        helper.push(pushObject);
    },

    pushNavigationRelatedToMyAccount (voice) {
        if (!voice) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '110',
            'eventname': 'private_area',
            'menu_items': voice
        };

        helper.log('Pushing navigation related to my account interaction!', true);
        helper.push(pushObject);
    },

    pushSaveToWallet (walletType) {
        let label = '';
        if (walletType) {
            label = (walletType === 'apple') ? 'add_to_the_wallet' : 'save_on_the_phone';
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '154',
            'eventname': 'loyalty_card',
            'label': label,
            'method': walletType
        };

        helper.log('Pushing save to wallet interaction!', true);
        helper.push(pushObject);
    },

    pushExperienceCoupon (action, label) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '197',
            'eventname': 'experience_coupon',
            'action': action,
            'label': label
        };

        helper.log('Pushing experience coupon event!', true);
        helper.push(pushObject);
    },

    pushCouponUsingType (action, coupon, label) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '196',
            'eventname': 'coupon_using_type',
            'action': action,
            'coupon': coupon,
            'label': label
        };

        helper.log('Pushing coupon using type event!', true);
        helper.push(pushObject);
    },

    pushMissionStart (missionName, points, section, missionId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '198',
            'eventname': 'mission_start',
            'label': missionName,
            'point': points ? points.toString() : '0',
            'type': section,
            'mission': missionId
        };

        helper.log('Pushing mission start event!', true);
        helper.push(pushObject);
    },

    pushMissionAction (missionName, points, action, missionId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '199',
            'eventname': 'mission_action',
            'label': missionName,
            'point': points ? points.toString() : '0',
            'action': action,
            'mission': missionId
        };

        helper.log('Pushing mission action event!', true);
        helper.push(pushObject);
    },

    pushMissionComplete (missionName, points, missionId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '200',
            'eventname': 'mission_complete',
            'label': missionName,
            'point': points ? points.toString() : '0',
            'mission': missionId
        };

        helper.log('Pushing mission complete event!', true);
        helper.push(pushObject);
    },

    pushUnsubscribeTalentStep1 () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '201',
            'eventname': 'unsubscribe_talent_step1'
        };
        helper.log('Pushing unsubscribe talent step 1 event!', true);
        helper.push(pushObject);
    },

    pushUnsubscribeTalentConfirmation () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '202',
            'eventname': 'unsubscribe_talent_confirmation'
        };
        helper.log('Pushing unsubscribe talent confirmation event!', true);
        helper.push(pushObject);
    },

    pushTalentCardInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '203',
            'eventname': 'talent_card'
        };
        helper.log('Pushing talent card interaction event!', true);
        helper.push(pushObject);
    },

    pushTalentCouponInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '204',
            'eventname': 'talent_coupon'
        };
        helper.log('Pushing talent coupon interaction event!', true);
        helper.push(pushObject);
    },

    pushTalentMenuInteraction (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '205',
            'eventname': 'talent_menu',
            'action': action
        };
        helper.log('Pushing talent menu interaction event!', true);
        helper.push(pushObject);
    },

    pushGameAction (gameName, points, gameId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '206',
            'eventname': 'game_action',
            'label': gameName,
            'point': points ? points.toString() : '0',
            'game': gameId,
            'action': 'play_now'
        };
        helper.log('Pushing game action event!', true);
        helper.push(pushObject);
    },

    pushGameComplete (gameName, points, gameId, action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '207',
            'eventname': 'game_complete',
            'label': gameName,
            'point': points ? points.toString() : '0',
            'game': gameId,
            'action': action
        };
        helper.log('Pushing game complete event!', true);
        helper.push(pushObject);
    },

    // complete your preferences
    pushProfileEnrichmentLoyaltyOnly () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '168',
            'eventname': 'customer_profile_enrichment_start',
            'step': 'step0-complete_your_preferences'
        };
        helper.log('Pushing customer profile enrichment - loyalty only');
        helper.push(pushObject);
    },

    // 7.145 PROFILE ENRICHMENT - STEP1
    pushProfileEnrichmentLoyaltyOnlyStep01 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '169',
            'eventname': 'customer_profile_enrichment',
            'step': 'step1',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 1');
        helper.push(pushObject);
    },

    // 7.146 PROFILE ENRICHMENT - STEP2
    pushProfileEnrichmentLoyaltyOnlyStep02 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '170',
            'eventname': 'customer_profile_enrichment',
            'step': 'step2',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 2');
        helper.push(pushObject);
    },

    // 7.147 PROFILE ENRICHMENT - STEP3
    pushProfileEnrichmentLoyaltyOnlyStep03 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '171',
            'eventname': 'customer_profile_enrichment',
            'step': 'step3',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 3');
        helper.push(pushObject);
    },

    // 7.148 PROFILE ENRICHMENT - STEP4
    pushProfileEnrichmentLoyaltyOnlyStep04 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '172',
            'eventname': 'customer_profile_enrichment',
            'step': 'step4',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 4');
        helper.push(pushObject);
    },

    // 7.149 PROFILE ENRICHMENT - STEP5
    pushProfileEnrichmentLoyaltyOnlyStep05 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '173',
            'eventname': 'customer_profile_enrichment',
            'step': 'step5',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 4');
        helper.push(pushObject);
    },

    // 7.150 PROFILE ENRICHMENT - STEP6
    pushProfileEnrichmentLoyaltyOnlyStep06 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '174',
            'eventname': 'customer_profile_enrichment',
            'step': 'step6',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 4');
        helper.push(pushObject);
    },

    // survey finished
    pushProfileEnrichmentLoyaltyOnlyFinished () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '176',
            'eventname': 'customer_profile_enrichment_thankyou',
            'step': 'step8-survey_completed'
        };
        helper.log('Pushing customer profile enrichment - survey finished');
        helper.push(pushObject);
    },

    // 7.153 PROFILE ENRICHMENT - leave the survey
    pushProfileEnrichmentLoyaltyOnlyLeavingSurvey (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '177',
            'eventname': 'customer_profile_enrichment',
            'step': 'leave_the_survey',
            'category': topic
        };
        helper.log('Pushing customer profile enrichment - leaving survey');
        helper.push(pushObject);
    },

    // 7.158 MY ORDERS AND RETURNS – PERSONAL AREA
    pushMyOrdersAndReturns (cta) {
        const pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '182',
            'eventname': 'my_orders_and_returns',
            'text': cta
        };
        helper.log('Pushing my orders and returns - personal area');
        helper.push(pushObject);
    },

    // 7.159 BUY IT AGAIN / SIMILAR PRODUCTS
    pushBuyItAgain (area, cta, sku) {
        const pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '183',
            'eventname': area,
            'text': cta,
            'product_id': sku
        };
        helper.log('Pushing buy it again - similar products');
        helper.push(pushObject);
    },

    // Login error
    pushLoginErrorMessage (errorMessage, loginStep) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID':'185',
            'eventname':'error_login',
            'message': errorMessage,
            'step': loginStep,
        };

        helper.log('Pushing customer error login message');
        helper.push(pushObject);
    },
};
